<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch4">
<div class="chapterHead"><p class="centerImage"><img alt="image" src="images/ch4.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">You know a chance to escape when you see one. You push the door. It swings open!</p>
<p class="para" style="text-indent: 5%;">Immediately the test tubes stop moving. You jump out. The men with the doctors’ masks are nowhere in sight. You run back to Liz’s tube and unseal her door.</p>
<p class="para" style="text-indent: 5%;">“Thanks!” Liz exclaims as she jumps out.</p>
<p class="para" style="text-indent: 5%;">“Are you alright?” you ask.</p>
<p class="para" style="text-indent: 5%;">“I’m fine,” she assures you. “But what about Jake? I can’t see him anymore. He disappeared into that opening in the wall!”</p>
<p class="para" style="text-indent: 5%;">Liz is right. Jake’s test tube is out of sight.</p>
<p class="para" style="text-indent: 5%;">You run to the opening in the wall. When you peer in, you can’t see Jake’s tube. But what you do see is so frightening it makes the hair on the back of your neck stand up!</p>
<p class="para" style="text-indent: 5%;">It’s the next step. And it couldn’t be worse.</p>
<p class="para" style="text-indent: 5%;">A sign at the end of a long tunnel flashes these words: <span class="smallCaps">SKIN SCRAPING CENTER</span>.</p>
<p class="para" style="text-indent: 5%;">“They’re going to skin Jake alive!” you breathe in horror.</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Try your best to save him on <span href="#/e9780545841733_ch098" title="Link target outside of Sample">PAGE 98</span>!</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841733_ch004.vue?6aaa019e